import { useState, useCallback } from "react";

const useStateMachine = (machine) => {
  const [currentState, setCurrentState] = useState(machine.start);
  const [previousState, setPreviousState] = useState(null);

  const send = useCallback(
    (data) => {
      if (data) {
        if (data.VORWURF) {
          const finalState = machine.results.find(
            (item) => item.key === data.VORWURF
          );

          setPreviousState(currentState);
          setCurrentState(finalState);
        }
      }
    },
    [currentState, machine.results]
  );

  const goBack = useCallback(() => {
    if (!previousState) return;

    setPreviousState(currentState);
    setCurrentState(previousState);
  }, [currentState, previousState]);

  return {
    currentState,
    send,
    goBack,
  };
};

export default useStateMachine;
